import { FormsModule } from '@angular/forms';
import { NgModule, Injectable } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CoursesRoutingModule } from './courses-routing.module';
import { CourseComponent } from './course/course.component';
import { CoursesDetailsComponent } from './courses-details/courses-details.component';
import * as Hammer from 'hammerjs';
import { HammerGestureConfig, HAMMER_GESTURE_CONFIG, HammerModule } from '@angular/platform-browser';
import { CourseListComponent } from './course-list/course-list.component';
import { CoursePermissionComponent } from './course-permission/course-permission.component';

@Injectable()
export class MyHammerConfig extends HammerGestureConfig {
  overrides = {
    swipe: { direction: Hammer.DIRECTION_ALL },
  } as any;
}
@NgModule({
  declarations: [CourseComponent, CoursesDetailsComponent, CourseListComponent, CoursePermissionComponent],
  imports: [
    CommonModule,
    CoursesRoutingModule,
    HammerModule,
    FormsModule
  ],
  providers: [
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: MyHammerConfig,
    },
  ],
})
export class CoursesModule { }
